type SelectForm = (count: number) => string;

export function incline(first: string, second: string, third: string): SelectForm {
  return function selectForm(count: number): string {
    let absCount = Math.abs(count);
    absCount %= 100;
    if (absCount >= 5 && absCount <= 20) return third;

    absCount %= 10;
    if (absCount === 1) return first;
    if (absCount >= 2 && absCount <= 4) return second;
    return third;
  };
}

export const inclineDays = incline('день', 'дня', 'дней');
